import { atom } from "recoil";

export const currentServicePage = atom({
    key: 'currentServicePage',
    default: 0
})
